import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(
  (theme) => ({
    root: {
      backgroundColor: theme.palette.common.white,
      height: "100%",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flex: "nowrap",
      padding: theme.spacing(4),
    },
  }),
  { name: "icip-admin-settings-styles", flip: null }
);

export default useStyles;
